import React from "react";
import { Grid } from "@mui/material";

const HalfColumn = ({ children }) => (
  <Grid size={{ xs: 3 ,md: 2}}>
    {children}
  </Grid>
);

export default HalfColumn;
